export const FORMA_PAGAMENTO = {
  BOLETO: "BOLETO",
  CREDITO: "CREDITO",
  DEBITO: "DEBITO",
  MANUAL: "MANUAL",
  PIX: "PIX"
};

export const FORMA_PAGAMENTO_LABEL = {
  BOLETO: "Boleto",
  DEBITO: "Débito",
  CREDITO: "Crédito",
  MANUAL: "Manual",
  PIX: "Pix"
};

export const NATUREZA_CONDICAO = {
  NAO_CLASSIFICADO: "NAO_CLASSIFICADO",
  A_VISTA: "A_VISTA",
  A_PRAZO: "A_PRAZO"
};

export const NATUREZA_CONDICAO_DEFAULT = NATUREZA_CONDICAO.NAO_CLASSIFICADO;

export const NATUREZA_CONDICAO_LABEL = {
  [NATUREZA_CONDICAO.NAO_CLASSIFICADO]: "Não classificado",
  [NATUREZA_CONDICAO.A_VISTA]: "À vista",
  [NATUREZA_CONDICAO.A_PRAZO]: "A prazo"
};

export const NATUREZA_CONDICAO_OPTIONS = [
  {
    text: NATUREZA_CONDICAO_LABEL[NATUREZA_CONDICAO.NAO_CLASSIFICADO],
    value: NATUREZA_CONDICAO.NAO_CLASSIFICADO
  },
  {
    text: NATUREZA_CONDICAO_LABEL[NATUREZA_CONDICAO.A_VISTA],
    value: NATUREZA_CONDICAO.A_VISTA
  },
  {
    text: NATUREZA_CONDICAO_LABEL[NATUREZA_CONDICAO.A_PRAZO],
    value: NATUREZA_CONDICAO.A_PRAZO
  }
];

const NATUREZA_CONDICAO_CHIP = {
  [NATUREZA_CONDICAO.NAO_CLASSIFICADO]: { color: "grey", textColor: "white" },
  [NATUREZA_CONDICAO.A_VISTA]: { color: "success", textColor: "white" },
  [NATUREZA_CONDICAO.A_PRAZO]: { color: "warning", textColor: "white" }
};

export function labelNaturezaCondicao(valor) {
  if (!valor || !NATUREZA_CONDICAO_LABEL[valor]) {
    return NATUREZA_CONDICAO_LABEL[NATUREZA_CONDICAO.NAO_CLASSIFICADO];
  }
  return NATUREZA_CONDICAO_LABEL[valor];
}

export function chipPropsNaturezaCondicao(valor) {
  const key =
    valor && NATUREZA_CONDICAO_CHIP[valor]
      ? valor
      : NATUREZA_CONDICAO.NAO_CLASSIFICADO;
  return NATUREZA_CONDICAO_CHIP[key];
}

export function isNaturezaCondicaoValida(valor) {
  return Boolean(valor && NATUREZA_CONDICAO_LABEL[valor]);
}

export const ORDERSTATUS = {
  ORCAMENTO_NOVO: "ORCAMENTO_NOVO",
  ORCAMENTO_PRECIFICADO: "ORCAMENTO_PRECIFICADO",
  ENVIADO: "ENVIADO",
  SEPARANDO: "SEPARANDO",
  PAGO: "PAGO",
  EMENTREGA: "EMENTREGA",
  ENTREGUE: "ENTREGUE",
  CANCELADO: "CANCELADO",
  PRONTO_RETIRADA: "PRONTO_RETIRADA",
  AGUARDANDOPAGAMENTO: "AGUARDANDOPAGAMENTO",
  EM_ANALISE: "EM_ANALISE"
};
